export enum appActions {
  ON_RESIZE = "ON_RESIZE",
  PUSH_ERROR = "PUSH_ERROR",
  POP_ERROR = "POP_ERROR",
}

export enum userActions {
  SET_ID = "SET_ID",
  SET_BALANCE = "SET_BALANCE",
}

// list of RGS actions (nothing to do with actual socket/http calls)
export enum RGSActions {
  LOGIN = "OPEN",
  INIT = "INIT",
  PLAY = "PLAY",
  BETS = "BETS",
  PLAY_PROMOTION = "PLAY_PROMOTION",
  BALANCE = "BALANCE",
  INCOMING = "INCOMING", // incoming messages that are not expected
  HEARTBEAT = "HEARTBEAT", // heartbeat command
  SUBSCRIPTION = "SUBSCRIPTION",
  LAST_DRAW_RESULTS = "LAST_DRAW_RESULTS",
  FAILED_BETS = "FAILED_BETS",
}

export enum gameActions {
  SET_SERVER_RESPONSE = "SET_SERVER_RESPONSE",
  SET_SERVER_STATUS = "SET_SERVER_STATUS",
  SET_SESSION_DATA = "SET_SESSION_DATA",
  // user data settings
  SET_USER_DATA = "SET_USER_DATA",
  // sets data in STATUS_DATA (used by display components, updated usually after spin ends)
  SET_STATUS_DATA = "SET_STATUS_DATA",
  // sets data about gameplay
  SET_GAMEPLAY_DATA = "SET_GAMEPLAY_DATA",
  // gameplay settings might include all game settings
  SET_GAMEPLAY_SETTINGS = "SET_GAMEPLAY_SETTINGS",
  // GUI data include stuff about current state of the GUI
  SET_GUI_DATA = "SET_GUI_DATA",
  // SETTINGS options
  SET_SETTINGS_DATA = "SET_SETTINGS_DATA",
}

export const ENABLE_CHEATABLE_RNG = true;
export const K_CM_TRY_RECONNECT_SOCKET = false;
